interface AppConfig {
    API_DOMAIN: string;
    LOCALE: string;
    PORTAL_LOGIN_URL: string;
    PORTAL_DASHBOARD_URL: string;
}

declare global {
    interface Window {
        __API_DOMAIN?: string;
        __PORTAL_LOGIN_URL?: string;
        __PORTAL_DASHBOARD_URL?: string;
    }
}

const appElement = document.documentElement;

export const config: AppConfig = {
    API_DOMAIN: window.__API_DOMAIN ?? "",
    LOCALE: appElement.dataset.locale || "en-GB",
    PORTAL_LOGIN_URL: window.__PORTAL_LOGIN_URL ?? "/",
    PORTAL_DASHBOARD_URL: window.__PORTAL_DASHBOARD_URL ?? "/dashboard",
};